import { fetchFamilyBullets } from '@gn-audio/core/api/product-catalogue/fetch-family-bullets';
import { fetchGroupBullets } from '@gn-audio/core/api/product-catalogue/fetch-group-bullets';
export var fetchBullets = function (productId, productType) {
    if (productType === void 0) { productType = "f" /* Family */; }
    var promise;
    switch (productType) {
        case "g" /* Group */:
            promise = fetchGroupBullets(productId);
            break;
        case "f" /* Family */:
        default:
            promise = fetchFamilyBullets(productId);
            break;
    }
    return promise;
};
